import { IconButton, IconButtonProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: "8px",
  color: theme.palette.shades.neutral[400],
  ".MuiTouchRipple-child": { borderRadius: "8px" },
}));

const ActionBarButton = (props: IconButtonProps) => {
  return (
    <StyledIconButton onClick={props.onClick}>
      {props.children}
    </StyledIconButton>
  );
};

export default ActionBarButton;
